import { render, staticRenderFns } from "./StudentActivityStepRead.vue?vue&type=template&id=4bd7a061"
import script from "./StudentActivityStepRead.vue?vue&type=script&lang=js"
export * from "./StudentActivityStepRead.vue?vue&type=script&lang=js"
import style0 from "./StudentActivityStepRead.vue?vue&type=style&index=0&id=4bd7a061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports